import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import App from "Containers/App";
import { configureStore } from "Redux/store";

const MainApp = () => (
  <Provider store={configureStore()}>
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </Provider>
);

export default MainApp;
